__turbopack_context__.v({
  "actions": "Modal-module__iX2sxG__actions",
  "content": "Modal-module__iX2sxG__content",
  "large": "Modal-module__iX2sxG__large",
  "modal": "Modal-module__iX2sxG__modal",
  "overlay": "Modal-module__iX2sxG__overlay",
  "title": "Modal-module__iX2sxG__title",
});
